/* eslint-disable */
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Row, Spacer, Collapse } from '@cleartrip/bento';
import { List } from 'components/travelsafe';

function TableRow(props) {
	const [collapse, setCollapse] = useState(!props.active);
	useEffect(() => {
		setCollapse(!props.active);
	}, [props.active]);

	function openDetails() {
		setCollapse(!collapse);
	}

	const tablelist = props.tablelist;
	const dotlist = props.dotlist;
	const bottomlist = props.bottomlist;
	const detailsList = props.detailsList;
	const detailsTitle = props.detailsTitle;
	const listPrefix = props.listPrefix;
	const rowClassName = classNames(
		'ba bc-neutral-100 br-4 mb-2',
		{
			'collapse-close': collapse,
			'collapse-open': !collapse,
		},
		props.className
	);

	return (
		<>
			<div className={rowClassName}>
				<>
					<div onClick={openDetails}>
						<Row className='mx-0'>{props.children}</Row>
					</div>
					{tablelist || dotlist || bottomlist || detailsList || detailsTitle ? (
						<Collapse pose={ collapse ? 'collapsed' : 'open'} className='w-100p'>
							<div className='px-2 pb-3 px-2--xs'>
								<div className='bb bn bc-neutral-100 bs-dashed mt-2 mb-3'></div>

								{/* details title  */}
								{detailsTitle && (
									<List.Title style={{ fontSize: '14px' }}>
										<Spacer className='pt-3' />
										{detailsTitle}
										<Spacer className='pt-3' />
									</List.Title>
								)}

								{/* dot list from parent */}
								{dotlist && (
									<div className='flex'>
										{listPrefix && <span className='my-2 fs-4 c-neutral-700 fw-500 pr-3 pl-1'>{listPrefix}</span>}
										<List>
											{props.dotlist.map((list, index) => (
												<List.Item
													listStyle={props.listStyle}
													dangerouslySetInnerHTML={{ __html: list }}
													className={classNames('fs-3 c-neutral-700 lh-copy lh-copy--xs')}
													key={index}
												/>
											))}
										</List>
									</div>
								)}

								{/* bottom list from parent */}

								{bottomlist && <p className='mt-2 fs-2 pl-3 pl-0--xs'>Airports: {props.bottomlist}</p>}

								{/* table list from parent */}

								{tablelist && (
									<div>
										<p className='mx-0--xs pt-2 c-neutral-700 fs-3 '>{tablelist.title}</p>
										{tablelist.allFlightDetails.length > 0 ? (
											<div className='mx-0--xs mt-3'>
												<table width='100%' style={{ borderCollapse: 'collapse' }} className='mb-6 bw-1 ba bc-neutral-100 br-4'>
													<thead className='bg-neutral-0'>
														<tr>
															<th className='ta-left px-3 py-2 ba bc-neutral-100'>Airline</th>
															<th className='ta-left px-3 py-2 ba bc-neutral-100'>Check-in</th>
															<th className='ta-left px-3 py-2 ba bc-neutral-100'>Entry Gates</th>
														</tr>
													</thead>
													<tbody>
														{tablelist.allFlightDetails.map((airline, index) => {
															return (
																<tr key={index} className='bb bw-1 bc-neutral-100'>
																	<td className='px-3 py-2 ba bc-neutral-100'>{airline.airlineName}</td>
																	<td className='px-3 py-2 ba bc-neutral-100'>{airline.checkInInfo}</td>
																	<td className='px-3 py-2 ba bc-neutral-100'>{airline.entryGates}</td>
																</tr>
															);
														})}
													</tbody>
												</table>
											</div>
										) : (
											<span></span>
										)}
									</div>
								)}
								{detailsList && (
									<div className='flex'>
										{listPrefix && (
											<>
												<span className='fs-4 c-neutral-700 fw-500 lh-copy lh-copy--xs pt-2'>{listPrefix}</span>
												<Spacer className='pr-2' />
											</>
										)}
										<List>
											<>
												{detailsList.map((list, idx) => {
													return (
														<>
															<List key={idx}>
																<Spacer className='pt-2' />
																<List.Title style={{ fontSize: '14px' }}>{list.title}</List.Title>
																{list.title && <Spacer className='pt-1' />}
																{list.description && (
																	<>
																		<p className='fs-3 c-neutral-700 lh-copy lh-copy--xs' dangerouslySetInnerHTML={{ __html: list.description }}></p>
																		{detailsList.length - 1 !== idx && <Spacer className='pt-3' />}
																	</>
																)}
																{list.listItems && (
																	<>
																		{list.listItems.map((item) => (
																			<List.Item className='lh-copy lh-copy--xs' dangerouslySetInnerHTML={{ __html: item }}></List.Item>
																		))}
																	</>
																)}
															</List>
														</>
													);
												})}
											</>
										</List>
									</div>
								)}
							</div>
						</Collapse>
					) : null}
				</>
			</div>
		</>
	);
}

TableRow.defaultProps = {
	active: false,
};

export default TableRow;
